import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const processUnitValue = (
  styleValue: StyleValue,
  defaultUnit: string,
): string | undefined => {
  if (styleValue.value === undefined || styleValue.value === null) {
    return undefined;
  }

  if (typeof styleValue.value === "string") {
    return styleValue.value;
  }

  // eslint-disable-next-line @typescript-eslint/no-base-to-string -- Updating typescript-eslint, should be fixed when appropriate
  return `${String(styleValue.value)}${defaultUnit}`;
};
